import qs from "query-string";
import axios from "axios";

import { httpClient } from "../utils/httpClient";

import { IFileAttachment } from "../types/entities";

export const getPresignedUrls = async ({
  attachmentable_type,
  filenames,
  projectId
}: {
  attachmentable_type: string;
  filenames: string[];
  projectId: string;
}): Promise<IFileAttachment[]> => {
  const response = await httpClient.get(
    `/projects/${projectId}/attachments/presign_urls`,
    {
      params: { attachmentable_type, filenames },
      paramsSerializer: providedParams => {
        return qs.stringify(providedParams, {
          arrayFormat: "bracket",
          skipEmptyString: true,
          skipNull: true
        });
      }
    }
  );

  return response.data;
};

export const uploadFile = async ({
  uploadURL,
  file,
  withContentType = false,
  onUploadProgress
}: {
  uploadURL: string;
  file: File;
  withContentType?: boolean;
  onUploadProgress: (progress: number) => void;
}): Promise<void> => {
  await axios.put(uploadURL, file, {
    onUploadProgress: progressEvent => {
      const progress = progressEvent.total
        ? Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        : 0;

      onUploadProgress(progress);
    },

    headers: {
      "Content-Type": withContentType ? file.type : ""
    }
  });
};
